module.exports = __webpack_public_path__ + "static/media/DSC_0058.4bcb5e6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0058.jpg
// module id = 684
// module chunks = 0